// extracted by mini-css-extract-plugin
export default {"container":"Upload_container__5-3d-","input":"Upload_input__2aqim","label":"Upload_label__HHMdh","error":"Upload_error__fj6wN"};